import { createFileRoute } from '@tanstack/react-router';

import { InternalUserRequired } from '@/features/login/ui/internal-user-required';
import { InternalWorkspaceLayout } from '@/internal/app/internal-workspace-layout';
import { ScrapingPage } from '@/internal/scraping/scraping-page';
import { PageLoader } from '@/shared/components/loader/page-loader';

export const Route = createFileRoute('/scraping')({
  component: () => (
    <InternalUserRequired pendingFallback={<PageLoader />}>
      <InternalWorkspaceLayout>
        <ScrapingPage />
      </InternalWorkspaceLayout>
    </InternalUserRequired>
  ),
});
